import { useState, useRef, useEffect } from 'react';
import { Button } from '../components/Button';
import api from '../api/api';
import EmailEditor from 'react-email-editor';
import {
	GridToolbarContainer,
	GridToolbarQuickFilter,
} from '@mui/x-data-grid-pro';
import { HiArrowLeft, HiArrowRight, HiCheck, HiOutlineCheck, HiPlus, HiOutlineChartBar } from 'react-icons/hi2';
import { NewsletterDettaglio } from './Newsletter/Dettaglio';
import { NewsletterBlacklist } from './Newsletter/Blacklist';
import { NewsletterStatistiche } from './Newsletter/Statistiche';
import { TabPanel } from '../components/TabPanel';
import { HiOutlineEnvelope, HiOutlineNoSymbol, HiOutlineChartBarSquare } from 'react-icons/hi2';
import { DataGridBase } from '../components/DataGrid/DataGridBase';
import { createPortal } from 'react-dom';
import Modal from '../components/Modal';
import { HiMail, HiOutlinePaperClip, HiOutlineX, HiSave, HiX, HiOutlineLink } from 'react-icons/hi';
import { MdCopyAll, MdDelete, MdEdit } from 'react-icons/md';
import { Input } from '../components/Input';
import { toast } from 'react-toastify';
import { Select as CustomSel } from '../components/Select';
import { CircularProgress, Tooltip } from '@mui/material';
import { MdInfoOutline } from 'react-icons/md';
import moment from 'moment';
import MultiSelectComponent from '../components/MultiSelect';
import Select from 'react-select';
import { knowAcces } from '../utils/utils';
import { HiOutlineDocumentText, HiOutlineClock, HiOutlineTrash } from 'react-icons/hi';
import newsletterBaseTemplate from '../data/newsletterBaseTemplate.json';
import newsletterMillerHrTemplate from '../data/newsletterMillerHrTemplate.json';

const MAX_ATTACHMENT_SIZE = 25 * 1024 * 1024;

// Project ID Unlayer: necessario perché il callback custom di upload immagini
// (registerCallback('image')) venga onorato. In modalità anonima (senza projectId)
// Unlayer ignora il callback e carica sul proprio CDN.
const UNLAYER_PROJECT_ID = 287262;

export const Newsletter = ({ screenSize }) => {
	// Permessi: solo admin/team_leader possono creare, modificare, eliminare, inviare.
	// Gli altri utenti vedono solo le newsletter già inviate, in sola lettura (con stats).
	const canManage = knowAcces(['admin', 'team_leader']);
	const [openModal, setOpenModal] = useState(false);
	const [openModalError, setOpenModalError] = useState(false);
	const [openModalCopy, setOpenModalCopy] = useState(false);
	const [openModalDettaglio, setOpenModalDettaglio] = useState(false);
	const [newsletter, setNewsletter] = useState([])
	// Tab di pagina: 1 = elenco newsletter, 2 = blacklist (bounce/spam/unsubscribe)
	const [tab, setTab] = useState(1);
	// Tab Statistiche e Blacklist sono strumenti di gestione: solo admin/team_leader.
	const tabs = [
		{ id: 1, text: 'Newsletter', icon: <HiOutlineEnvelope size={20} className='tab-icon' /> },
		...(canManage ? [
			{ id: 2, text: 'Statistiche', icon: <HiOutlineChartBarSquare size={20} className='tab-icon' /> },
			{ id: 3, text: 'Blacklist', icon: <HiOutlineNoSymbol size={20} className='tab-icon' /> },
		] : []),
	];
	const [operazione, setOperazione] = useState("inserimento");
	const [newsletterSel, setNewsletterSel] = useState(null);
	const [titolo, setTitolo] = useState("");
	const [procedi, setProcedi] = useState(false);
	const [conferma, setConferma] = useState(false);
	const [htmlMail, setHtmlMail] = useState(null);
	const [ccnl, setCcnl] = useState([]);
	const emailEditorRef = useRef(null);
	const [loading, setLoading] = useState(false);
	// Loader dedicato al pulsante "Genera URL da file" (upload in corso).
	const [generatingUrl, setGeneratingUrl] = useState(false);
	const [idSel, setIdSel] = useState(null)
	const [allegati, setAllegati] = useState([]);

	// Programmazione invio: lista programmazioni del template + data/ora scelta.
	const [programmazioni, setProgrammazioni] = useState([]);
	const [programmaData, setProgrammaData] = useState(''); // valore datetime-local (ora locale)
	// Storico di TUTTI gli invii partiti (manuali + programmati), da newsletter_invio_destinatari.
	const [inviiEffettuati, setInviiEffettuati] = useState([]);

	// Autosave: timer di debounce + flag "editor caricato" per ignorare gli eventi
	// 'design:updated' che si scatenano durante loadDesign iniziale.
	// saveStatus pilota l'indicatore visibile in toolbar.
	const autosaveTimerRef = useRef(null);
	const editorReadyRef = useRef(false);
	const [saveStatus, setSaveStatus] = useState('idle'); // 'idle' | 'saving' | 'saved' | 'error'

	// Nuovo modello filtri (5 elenchi + filtri AND)
	const [elenchiSel, setElenchiSel] = useState([]); // numeri 1..5
	const [filtroCcnl, setFiltroCcnl] = useState([]);
	const [filtroFatt, setFiltroFatt] = useState([]);
	const [filtroDim, setFiltroDim] = useState({ enabled: false, mese: moment().subtract(2, 'month').format('YYYY-MM'), op: '<=', valore: 20 });
	const [mailExtra, setMailExtra] = useState('');
	const [preview, setPreview] = useState({ totale: 0, per_elenco: [] });
	const [sampleSearch, setSampleSearch] = useState('');

	// Le descrizioni vengono caricate da /newsletter/regole-elenchi (vedi useEffect)
	// così la regola è centralizzata sul backend ed è documentata in un solo posto.
	const ELENCHI_DEFAULT = [
		{ id: 1, label: 'Clienti HR (Italia)', descrizione: '' },
		{ id: 2, label: 'Clienti HR Estero', descrizione: '' },
		{ id: 3, label: 'Team interno', descrizione: '' },
		{ id: 4, label: 'Non assegnati Italia', descrizione: '' },
		{ id: 5, label: 'Non assegnati Estero', descrizione: '' },
	];
	const [ELENCHI, setELENCHI] = useState(ELENCHI_DEFAULT);
	const FATTURAZIONE_OPTIONS = [
		{ value: 'Z', label: 'Zucchetti' },
		{ value: 'I', label: 'IIPay' },
		{ value: 'B', label: 'B-Point' },
		{ value: 'G', label: 'Gratuiti' },
	];

	const columns = [
		{
			field: 'Azioni',
			headerName: 'Azioni',
			width: screenSize > '768' ? 150 : 70,
			headerAlign: 'center',
			align: 'center',
			filterable: false,
			renderCell: (params) => {
				return (
					<>
						<div className='hidden md:flex flex-nowrap '>
							{canManage && (
								<>
									<Button
										className='edit-button'
										type='button'
										icon={<MdEdit className='button-icon' />}
										onClick={async () => { editorReadyRef.current = false; setSaveStatus('idle'); setIdSel(params.row.id); setConferma(false); setProcedi(false); setNewsletterSel(params.row); setTitolo(params.row.titolo); setAllegati(Array.isArray(params.row.allegati) ? params.row.allegati : []); setProgrammaData(''); loadProgrammazioni(params.row.id); setOperazione("modifica"); setOpenModal(true) }}
									/>

									<Button
										className='edit-button'
										type='button'
										icon={<MdCopyAll className='button-icon' />}
										onClick={async () => { setNewsletterSel(params.row); setOpenModalCopy(true) }}
									/>
								</>
							)}
							<Button
								className={`edit-button ${!params.row.data_invio ? 'opacity-30 cursor-not-allowed' : ''}`}
								type='button'
								disabled={!params.row.data_invio}
								title={params.row.data_invio ? 'Statistiche invio' : 'Newsletter non ancora inviata'}
								icon={<HiOutlineChartBar className='button-icon' />}
								onClick={async () => { setIdSel(params.row.id); setNewsletterSel(params.row); setOpenModalDettaglio(true) }}
							/>
							{canManage && (
								<Button
									className='edit-button'
									type='button'
									icon={<MdDelete className='button-icon text-red-500' />}
									onClick={async () => { setNewsletterSel(params.row); setOpenModalError(true) }}
								/>
							)}
						</div>

					</>
				);
			},
		},
		{
			field: 'titolo',
			headerName: 'Titolo',
			width: 150,
			flex: screenSize > '768' ? 1 : 0,
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'data_invio',
			headerName: 'Data invio',
			width: 150,
			flex: screenSize > '768' ? 1 : 0,
			headerAlign: 'center',
			align: 'center',
			renderCell: (params) => params.value ? moment(params.value).format("DD/MM/YYYY") : ""
		},

	];




	// Helper: promisify le API non-promise di Unlayer (saveDesign / exportHtml)
	// così possiamo davvero await-are il salvataggio prima di proseguire.
	const saveDesignAsync = () =>
		new Promise((resolve, reject) => {
			try {
				emailEditorRef.current.editor.saveDesign((design) => resolve(design));
			} catch (e) {
				reject(e);
			}
		});

	const exportHtmlAsync = () =>
		new Promise((resolve, reject) => {
			try {
				emailEditorRef.current.editor.exportHtml((data) => resolve(data));
			} catch (e) {
				reject(e);
			}
		});

	// Un design Unlayer è "vuoto" se non ha righe nel body OPPURE se nessuna
	// colonna contiene blocchi di contenuto (un editor nuovo può avere una riga
	// vuota di default). Lo usiamo come rete di sicurezza per non sovrascrivere
	// contenuto valido con un design vuoto catturato da saveDesign() prima che
	// loadDesign abbia popolato l'editor, e per non chiedere conferme inutili.
	const isDesignEmpty = (design) => {
		try {
			const rows = design && design.body && design.body.rows;
			if (!Array.isArray(rows) || rows.length === 0) return true;
			const hasContent = rows.some((r) =>
				Array.isArray(r.columns) &&
				r.columns.some((c) => Array.isArray(c.contents) && c.contents.length > 0)
			);
			return !hasContent;
		} catch (e) {
			return true;
		}
	};

	const safeParseDesign = (contenuto) => {
		if (!contenuto) return null;
		try {
			return typeof contenuto === 'string' ? JSON.parse(contenuto) : contenuto;
		} catch (e) {
			return null;
		}
	};

	// Helper centralizzato: salva su DB e tiene SINCRONIZZATO `newsletterSel.contenuto`
	// con il design appena salvato. Risolve il bug "Procedi -> Indietro perde le modifiche":
	// al rimontaggio dell'editor, onReady ricarica `newsletterSel.contenuto` che ora
	// contiene la versione aggiornata, non quella iniziale.
	// Ritorna l'id della newsletter persistita (nuova o esistente).
	const persistDesign = async (design) => {
		// RETE DI SICUREZZA (fix bug "sparisce testo e grafica"):
		// non sovrascrivere mai un contenuto valido con un design VUOTO.
		// La causa del bug era saveDesign() chiamato prima che loadDesign avesse
		// popolato l'editor (race), che restituiva un design vuoto poi persistito.
		if (isDesignEmpty(design)) {
			const prev = safeParseDesign(newsletterSel?.contenuto);
			if (prev && !isDesignEmpty(prev)) {
				console.warn('persistDesign: ignorato salvataggio di design VUOTO su newsletter con contenuto');
				return newsletterSel?.id ?? idSel;
			}
		}
		const contenuto = JSON.stringify(design);
		if (operazione === "inserimento") {
			const r = await api.post("/newsletter", { ns: { contenuto, titolo } });
			const newId = r?.data?.insertId;
			if (newId) {
				setIdSel(newId);
				setOperazione("modifica");
				setNewsletterSel({ id: newId, titolo, contenuto, allegati });
			}
			return newId;
		} else {
			await api.put("/newsletter", { ns: { contenuto, titolo, id: newsletterSel.id } });
			setNewsletterSel((prev) => prev ? { ...prev, titolo, contenuto } : prev);
			return newsletterSel.id;
		}
	};

	// Garantisce che esista un id per la newsletter corrente (creando un placeholder
	// se siamo ancora in "inserimento"). Necessario per associare gli allegati su disco.
	const ensureNewsletterId = async () => {
		if (idSel) return idSel;
		const design = await saveDesignAsync();
		return await persistDesign(design);
	};

	const handleProcedi = async () => {
		setLoading(false);
		try {
			const design = await saveDesignAsync();
			// Se l'editor non è ancora pronto restituisce un design vuoto: non
			// procedere con un HTML vuoto se in realtà esiste contenuto salvato.
			if (isDesignEmpty(design) && !isDesignEmpty(safeParseDesign(newsletterSel?.contenuto))) {
				toast.info("Attendi il caricamento del contenuto e riprova");
				return;
			}
			const persistedId = await persistDesign(design);
			const { html } = await exportHtmlAsync();
			setHtmlMail(html);
			setElenchiSel([]);
			setFiltroCcnl([]);
			setFiltroFatt([]);
			setFiltroDim({ enabled: false, mese: moment().subtract(2, 'month').format('YYYY-MM'), op: '<=', valore: 20 });
			setMailExtra('');
			setPreview({ totale: 0, per_elenco: [] });
			setProcedi(true);
			setConferma(false);
			loadProgrammazioni(idSel || persistedId);
			loadNewsletter();
		} catch (e) {
			console.error("handleProcedi error", e);
			toast.error("Errore durante il salvataggio");
		}
	}


	const loadNewsletter = async () => {
		const aziende = await api.get("/newsletter");
		setNewsletter(aziende.data)
	}
	useEffect(() => {
		loadNewsletter();
		loadCcnl();
		loadRegoleElenchi();
	}, []);


	const loadCcnl = async () => {

		const rispListe = await api.get(`/ccnl/newsletter`);
		setCcnl(rispListe.data)
	}

	const loadRegoleElenchi = async () => {
		try {
			const resp = await api.get(`/newsletter/regole-elenchi`);
			if (Array.isArray(resp.data) && resp.data.length) {
				setELENCHI(resp.data);
			}
		} catch (err) {
			console.error('Errore caricamento regole elenchi:', err);
		}
	}



	const exportSave = async () => {
		try {
			if (autosaveTimerRef.current) { clearTimeout(autosaveTimerRef.current); autosaveTimerRef.current = null; }
			setSaveStatus('saving');
			const design = await saveDesignAsync();
			await persistDesign(design);
			setSaveStatus('saved');
			await loadNewsletter();
			toast.success("Salvataggio avvenuto con successo");
		} catch (e) {
			console.error("exportSave error", e);
			setSaveStatus('error');
			toast.error("Errore durante il salvataggio");
		}
	};





	const sendTest = async () => {
		try {
			const mailTest = window.prompt('Indirizzo email per il test:', '');
			if (!mailTest) return;

			// IMPORTANTE: ri-esportiamo SEMPRE l'HTML dal design corrente.
			// Non usare la variabile `htmlMail` come cache: viene popolata da
			// "Procedi" e non riflette modifiche fatte dopo (es. cambio font size).
			// Era questo il bug riportato da Diego: nei test arrivava sempre il
			// carattere impostato prima di Procedi, ignorando le modifiche successive.
			const design = await saveDesignAsync();
			// Non inviare un test vuoto se l'editor non ha ancora caricato il contenuto.
			if (isDesignEmpty(design) && !isDesignEmpty(safeParseDesign(newsletterSel?.contenuto))) {
				toast.info("Attendi il caricamento del contenuto e riprova");
				return;
			}
			const persistedId = await persistDesign(design);
			const { html } = await exportHtmlAsync();
			setHtmlMail(html);
			const currentId = idSel || persistedId || (newsletterSel && newsletterSel.id);

			await api.post('/newsletter/test', { idSel: currentId, mailTest, titolo, contenuto: html });

			toast.success("Mail test inviata con successo");
		} catch (e) {
			console.error("sendTest error", e);
			toast.error("Errore durante l'invio");
		}
	}

	const aggiornaDb = async () => {
		const result = await api.get('/t');
		console.log(result);
	};


	// onLoad: iframe caricato. Non chiamare loadDesign qui — l'editor interno
	// potrebbe non essere ancora pronto (bug intermittente "grafica sparisce").
	const onLoad = () => {
		// no-op: il caricamento del design avviene in onReady (vedi sotto)
	}



	const buildFiltri = () => ({
		elenchi: elenchiSel,
		ccnl: filtroCcnl.map(o => o.value),
		tipologiaFatturazione: filtroFatt.map(o => o.value),
		dimensione: filtroDim.enabled
			? { mese: filtroDim.mese + '-01', op: filtroDim.op, valore: Number(filtroDim.valore) }
			: null,
		mailExtra: mailExtra
			? mailExtra.split(/[\s,;\n]+/).map(s => s.trim()).filter(Boolean)
			: [],
	});

	const refreshPreview = async () => {
		try {
			if (elenchiSel.length === 0 && !mailExtra) {
				setPreview({ totale: 0, per_elenco: [] });
				return;
			}
			const r = await api.post('/newsletter/preview-destinatari', { filtri: buildFiltri() });
			setPreview(r.data);
		} catch (e) {
			console.error(e);
		}
	};

	useEffect(() => {
		if (procedi) refreshPreview();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [procedi, elenchiSel, filtroCcnl, filtroFatt, filtroDim, mailExtra]);

	const toggleElenco = (id) => {
		setConferma(false);
		setElenchiSel(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
	};

	const sendToCluster = async () => {
		try {
			setLoading(true)
			await api.post('/newsletter/send', {
				idSel: idSel,
				titolo: titolo,
				contenuto: htmlMail,
				filtri: buildFiltri(),
			})
			setLoading(false)
			loadNewsletter();
			toast.success("Newsletter inviata con successo")
			// Reset stato wizard e chiudi la modale di composizione,
			// poi apri direttamente il dettaglio invio della newsletter appena spedita.
			setConferma(false)
			setProcedi(false)
			setOpenModal(false)
			// Garantisce che l'header della modale dettaglio mostri il titolo corretto
			// anche per newsletter appena create (quando newsletterSel non era ancora stato set).
			setNewsletterSel((prev) => prev && prev.id === idSel ? prev : { id: idSel, titolo })
			setOpenModalDettaglio(true)
		} catch {
			setLoading(false)
			toast.error("Errore durante l'invio della newsletter")
		}
	}





	// --- Programmazione invio ---------------------------------------------
	const loadProgrammazioni = async (idNewsletter) => {
		if (!idNewsletter) { setProgrammazioni([]); setInviiEffettuati([]); return; }
		try {
			const [rProg, rInvii] = await Promise.all([
				api.get(`/newsletter/${idNewsletter}/programmazioni`),
				api.get(`/newsletter/${idNewsletter}/invii`),
			]);
			setProgrammazioni(Array.isArray(rProg.data) ? rProg.data : []);
			setInviiEffettuati(Array.isArray(rInvii.data) ? rInvii.data : []);
		} catch (e) {
			console.error('loadProgrammazioni error', e);
		}
	};

	const scheduleNewsletter = async () => {
		try {
			if (!programmaData) { toast.info('Seleziona data e ora di invio'); return; }
			const dt = new Date(programmaData); // interpretato come ora locale
			if (isNaN(dt.getTime())) { toast.error('Data non valida'); return; }
			if (dt.getTime() <= Date.now()) { toast.error('La data deve essere nel futuro'); return; }
			const id = idSel || (newsletterSel && newsletterSel.id);
			if (!id) { toast.error('Salva prima la newsletter'); return; }

			await api.post('/newsletter/programmazione', {
				idNewsletter: id,
				programmataPer: dt.toISOString(), // ISO UTC
				filtri: buildFiltri(),
				numeroDestinatari: preview.totale,
				titolo: titolo,
				htmlContenuto: htmlMail,
			});
			setProgrammaData('');
			await loadProgrammazioni(id);
			toast.success('Invio programmato con successo');
		} catch (e) {
			console.error('scheduleNewsletter error', e);
			toast.error(e?.response?.data?.error || "Errore durante la programmazione");
		}
	};

	const deleteProgrammazione = async (idProg) => {
		try {
			await api.delete(`/newsletter/programmazione/${idProg}`);
			await loadProgrammazioni(idSel || (newsletterSel && newsletterSel.id));
			toast.success('Programmazione eliminata');
		} catch (e) {
			console.error('deleteProgrammazione error', e);
			toast.error(e?.response?.data?.error || "Errore durante l'eliminazione");
		}
	};

	const deleteNewsletter = async () => {
		try {




			await api.delete(`/newsletter/${newsletterSel.id}`)

			loadNewsletter();
			setOpenModalError(false)
			toast.success("Eliminato con successo")

		} catch {
			toast.error("Errore durante il salvataggio")
		}

	};

	const handleFileChange = async (e) => {
		const files = Array.from(e.target.files || []);
		// Reset input subito così l'utente può ricaricare lo stesso file dopo un errore.
		e.target.value = '';
		if (!files.length) return;

		const totalSize = files.reduce((acc, file) => acc + file.size, 0);
		if (totalSize > MAX_ATTACHMENT_SIZE) {
			toast.error('Files troppo grandi');
			return;
		}

		try {
			const id = await ensureNewsletterId();
			if (!id) {
				toast.error('Salva la newsletter prima di allegare un file');
				return;
			}
			let latest = allegati;
			for (const file of files) {
				const fd = new FormData();
				fd.append('file', file);
				const r = await api.post(`/newsletter/${id}/allegati`, fd, {
					headers: { 'Content-Type': undefined },
				});
				latest = r.data;
				setAllegati(latest);
			}
			setNewsletterSel((prev) => prev ? { ...prev, allegati: latest } : prev);
			toast.success('Allegato caricato');
		} catch (err) {
			console.error('handleFileChange error', err);
			toast.error("Errore durante l'upload dell'allegato");
		}
	};


	const handleRemove = async () => {
		if (!idSel) {
			setAllegati([]);
			return;
		}
		try {
			await api.delete(`/newsletter/${idSel}/allegati`);
			setAllegati([]);
			setNewsletterSel((prev) => prev ? { ...prev, allegati: [] } : prev);
		} catch (err) {
			console.error('handleRemove error', err);
			toast.error("Errore durante la rimozione degli allegati");
		}
	}

	// Rimuove UN singolo allegato dalla lista (chiamato dal pulsante X su ogni chip).
	// `fileOnDisk` è il nome random sul filesystem (chiave stabile, URL-safe).
	const handleRemoveOne = async (fileOnDisk) => {
		// Se siamo ancora in inserimento non c'è id: rimuovo solo dallo stato locale
		if (!idSel) {
			setAllegati((prev) => prev.filter((a) => a.file !== fileOnDisk));
			return;
		}
		try {
			const r = await api.delete(`/newsletter/${idSel}/allegati/${fileOnDisk}`);
			const next = Array.isArray(r.data) ? r.data : [];
			setAllegati(next);
			setNewsletterSel((prev) => prev ? { ...prev, allegati: next } : prev);
		} catch (err) {
			console.error('handleRemoveOne error', err);
			toast.error("Errore durante la rimozione dell'allegato");
		}
	}




	const handleAttach = () => {

		document.getElementById("uploadDoc").click()

	}

	// Copia testo negli appunti con fallback per browser senza Clipboard API
	// (la Clipboard API richiede contesto sicuro: https o localhost).
	const copyToClipboard = async (text) => {
		try {
			if (navigator.clipboard && window.isSecureContext) {
				await navigator.clipboard.writeText(text);
				return true;
			}
		} catch (e) {
			// cade nel fallback execCommand
		}
		try {
			const ta = document.createElement('textarea');
			ta.value = text;
			ta.style.position = 'fixed';
			ta.style.opacity = '0';
			document.body.appendChild(ta);
			ta.focus();
			ta.select();
			const ok = document.execCommand('copy');
			document.body.removeChild(ta);
			return ok;
		} catch (e) {
			return false;
		}
	};

	// "Genera URL da file": carica un file qualsiasi sul nostro S3 e copia
	// l'URL pubblico negli appunti. L'utente lo incolla poi dove vuole
	// (es. come link di un bottone nell'editor). Non viene allegato alla newsletter.
	const handleGenerateUrl = () => {
		if (generatingUrl) return; // evita doppio click durante l'upload
		document.getElementById("uploadUrlFile").click();
	};

	const handleGenerateUrlFileChange = async (e) => {
		const file = (e.target.files || [])[0];
		// Reset subito così si può ricaricare lo stesso file dopo un errore.
		e.target.value = '';
		if (!file) return;

		if (file.size > MAX_ATTACHMENT_SIZE) {
			toast.error('File troppo grande');
			return;
		}

		setGeneratingUrl(true);
		try {
			const fd = new FormData();
			fd.append('file', file);
			const r = await api.post('/newsletter/upload-url', fd, {
				headers: { 'Content-Type': undefined },
			});
			const url = r.data?.url;
			if (!url) throw new Error('URL mancante nella risposta');
			const copied = await copyToClipboard(url);
			if (copied) {
				toast.success('URL del file copiato negli appunti');
			} else {
				// Se la copia automatica fallisce, mostriamo comunque l'URL.
				window.prompt('Copia manualmente questo URL:', url);
			}
		} catch (err) {
			console.error('handleGenerateUrlFileChange error', err);
			toast.error("Errore durante l'upload del file");
		} finally {
			setGeneratingUrl(false);
		}
	};

	// Carica nell'editor un template. Se c'è già contenuto chiede conferma
	// (l'operazione sovrascrive il design corrente).
	const initFromTemplate = async (template = newsletterBaseTemplate, label = 'base') => {
		try {
			const current = await saveDesignAsync();
			if (!isDesignEmpty(current)) {
				const ok = window.confirm(`Sostituire il contenuto attuale con il template ${label}? Le modifiche non salvate verranno perse.`);
				if (!ok) return;
			}
			// Clone profondo per evitare di mutare l'oggetto importato (riutilizzabile).
			const design = JSON.parse(JSON.stringify(template));
			emailEditorRef.current.editor.loadDesign(design);
			// loadDesign emette design:updated → l'autosave salverà da solo,
			// ma forziamo un salvataggio immediato per coerenza dell'indicatore.
			setSaveStatus('saving');
			await persistDesign(design);
			setSaveStatus('saved');
			toast.success(`Template ${label} caricato`);
		} catch (e) {
			console.error('initFromTemplate error', e);
			toast.error('Errore durante il caricamento del template');
		}
	};


	const copyNewsletter = async () => {
		try {



			await api.post("/newsletter", {
				ns: { contenuto: newsletterSel.contenuto, titolo: "COPIA - " + newsletterSel.titolo },
				copyAllegatiFrom: newsletterSel.id,
			})



			loadNewsletter();
			setOpenModalCopy(false)
			toast.success("Copiato con successo")
		} catch {
			toast.error("Errore durante il salvataggio")
		}

	};




	// Autosave debounced: salva la newsletter dopo 1.5s di inattività.
	// Risolve il bug riportato dal cliente ("la grafica sparisce") che si
	// verificava uscendo dalla schermata senza premere Salva.
	const scheduleAutosave = () => {
		if (!editorReadyRef.current) return;
		if (autosaveTimerRef.current) clearTimeout(autosaveTimerRef.current);
		autosaveTimerRef.current = setTimeout(async () => {
			try {
				setSaveStatus('saving');
				const design = await saveDesignAsync();
				await persistDesign(design);
				setSaveStatus('saved');
			} catch (e) {
				console.error('autosave error', e);
				setSaveStatus('error');
			}
		}, 1500);
	};

	// onReady: l'editor è effettivamente pronto a ricevere comandi.
	// Carichiamo qui il design (e non in onLoad) per evitare race con l'iframe.
	const onReady = () => {
		try {
			const ed = emailEditorRef.current.editor;
			editorReadyRef.current = false;

			// L'autosave deve partire SOLO dopo che l'editor è davvero pronto,
			// altrimenti un saveDesign() prematuro cattura un editor vuoto e
			// sovrascrive il contenuto (bug "sparisce testo e grafica").
			ed.addEventListener('design:updated', () => {
				scheduleAutosave();
			});

			// Upload immagini dell'editor sul NOSTRO S3 (non sul CDN Unlayer).
			// Registriamo il callback sia sull'istanza editor sia sul global unlayer.
			const imageUploadCb = async (file, done) => {
				try {
					const fd = new FormData();
					fd.append('file', file.attachments[0]);
					const r = await api.post('/newsletter/editor-image', fd, {
						headers: { 'Content-Type': undefined },
					});
					done({ progress: 100, url: r.data.url });
				} catch (err) {
					console.error('editor image upload error', err);
					toast.error("Errore upload immagine");
					done({ progress: 100, url: '' });
				}
			};
			try { ed.registerCallback('image', imageUploadCb); } catch (e) { console.error('registerCallback image error', e); }
			try {
				if (window.unlayer && window.unlayer.registerCallback) {
					window.unlayer.registerCallback('image', imageUploadCb);
				}
			} catch (e) { console.error('window.unlayer registerCallback error', e); }

			const parsed = safeParseDesign(newsletterSel?.contenuto);
			if (operazione === "modifica" && parsed && !isDesignEmpty(parsed)) {
				// Abilita l'autosave SOLO quando il design è effettivamente caricato.
				let enabled = false;
				const enable = () => { if (!enabled) { enabled = true; editorReadyRef.current = true; } };
				try { ed.addEventListener('design:loaded', enable); } catch (e) { /* versioni Unlayer senza evento */ }
				ed.loadDesign(parsed);
				// Fallback se 'design:loaded' non scatta: abilita comunque dopo 3s.
				setTimeout(enable, 3000);
			} else {
				// Nuova newsletter (o contenuto vuoto): editor parte vuoto,
				// nessun rischio di sovrascrivere → autosave abilitato subito.
				editorReadyRef.current = true;
			}
		} catch (e) {
			console.error("onReady error", e);
		}
	};
	function CustomToolbar() {
		return (
			<GridToolbarContainer>
				<div className='w-full flex flex-wrap-reverse md:flex-nowrap justify-between md:space-x-5 mb-2 gap-y-1'>
					<div className='flex md:flex-nowrap md:w-fit w-full flex-wrap justify-center md:justify-start gap-x-2'>
						<GridToolbarQuickFilter placeholder='Cerca...' />
					</div>
					<div className='flex justify-center md:justify-end md:mx-0 mx-auto'>
						{canManage && (
							<Button
								className='success-button'
								size='md'
								text={'Nuovo'}
								icon={<HiPlus className='button-icon' />}
								onClick={() => { editorReadyRef.current = false; setSaveStatus('idle'); setIdSel(null); setProcedi(false); setOperazione("inserimento"); setTitolo(""); setAllegati([]); setProgrammazioni([]); setProgrammaData(''); setOpenModal(true) }}
							/>
						)}
					</div>
				</div>
			</GridToolbarContainer>
		);
	}

	// Programmazioni pending (future, gestibili). Lo storico invii usa inviiEffettuati.
	const programmazioniPending = programmazioni.filter((p) => p.stato !== 'inviata');

	return (
		<>

			{openModalDettaglio && createPortal(
				<Modal isOpen={openModalDettaglio} closeButton={() => setOpenModalDettaglio(false)} headerText={`Dettaglio invio - ${newsletterSel?.titolo || ''}`}>
					<NewsletterDettaglio idNewsletter={idSel} />
				</Modal>,
				document.getElementById("portalModal")
			)}
			{openModalCopy && createPortal(
				<Modal isOpen={openModalCopy} closeButton={() => setOpenModalCopy(false)} leftButtons={

					<Button
						className="principal-button z-[110]"
						text={"Salva"}
						type="button"
						icon={<HiOutlineCheck className="button-icon" />}
						onClick={async () => {
							copyNewsletter()
						}}
					/>
				}>
					Sei sicuro di voler copiare la newsletter selezionata?
				</Modal>,
				document.getElementById("portalModal")
			)}
			{openModalError && createPortal(
				<Modal isOpen={openModalError} closeButton={() => setOpenModalError(false)} headerText={"Elimina newsletter"} leftButtons={

					<Button
						className="principal-button z-[110]"
						text={"Elimina"}
						type="button"
						icon={<HiOutlineCheck className="button-icon" />}
						onClick={async () => {
							deleteNewsletter()
						}}
					/>
				}>
					Sei sicuro di voler eliminare la newsletter selezionata?
				</Modal>,
				document.getElementById("portalModal")
			)}

			{openModal && createPortal(
				<Modal isOpen={openModal} closeButton={async () => {
					// Flush autosave: se c'è un timer pendente, salviamo subito prima
					// di chiudere per non perdere modifiche fatte nell'ultimo secondo.
					if (autosaveTimerRef.current) {
						clearTimeout(autosaveTimerRef.current);
						autosaveTimerRef.current = null;
						try {
							const design = await saveDesignAsync();
							await persistDesign(design);
						} catch (e) { console.error('flush autosave on close', e); }
					}
					editorReadyRef.current = false;
					setSaveStatus('idle');
					setOpenModal(false);
					loadNewsletter();
				}} fullHeight>

					<div className="h-full flex flex-col">

						<div className='w-full h-full flex z-50 relative flex-col gap-2'>
							<div className='flex flex-row justify-between items-end'><div className=''>  <Input
								type="text"
								label={"Oggetto"}
								name=""
								onChange={(e) => { setTitolo(e.target.value); scheduleAutosave(); }}
								value={titolo}
								disabled={false}
							/></div>

								<div className='flex gap-2 items-center'>
									<span className='text-xs text-gray-500 min-w-[100px] text-right'>
										{saveStatus === 'saving' && '⏳ Salvataggio…'}
										{saveStatus === 'saved' && '✓ Salvato'}
										{saveStatus === 'error' && '⚠ Errore salvataggio'}
									</span>
									{!procedi ? <>


										<Button
											className='success-button'
											size='md'
											text={'Test'}
											icon={<HiMail className='button-icon' />}
											onClick={sendTest}
										/>

										<Button
											className='success-button'
											size='md'
											text={'Allega'}
											icon={<HiOutlinePaperClip className='button-icon' />}
											onClick={handleAttach}
										/>

										<Button
											className='success-button'
											size='md'
											disabled={generatingUrl}
											text={generatingUrl ? 'Caricamento…' : 'Genera URL da file'}
											icon={generatingUrl
												? <CircularProgress size={16} color='inherit' className='button-icon' />
												: <HiOutlineLink className='button-icon' />}
											onClick={handleGenerateUrl}
										/>

										<Button
											className='success-button'
											size='md'
											text={'Salva'}
											icon={<HiSave className='button-icon' />}
											onClick={exportSave}
										/>
										<Button
											className='success-button'
											size='md'
											text={'Procedi'}
											icon={<HiArrowRight className='button-icon' />}
											onClick={handleProcedi}
										/>
									</> :
										<>
											{preview.totale > 0 ? <Button
												className='success-button'
												size='md'
												text={conferma ? 'Annulla' : `Conferma e invia (${preview.totale})`}
												icon={conferma ? <HiX /> : <HiMail className='button-icon' />}
												onClick={() => setConferma(!conferma)}
											/> : ""}
											<Button
											className='success-button'
											size='md'
											text={'Test'}
											icon={<HiMail className='button-icon' />}
											onClick={sendTest}
										/>
											<Button
												className='success-button'
												size='md'
												text={'Indietro'}
												icon={<HiArrowLeft className='button-icon' />}
												onClick={() => setProcedi(false)}
											/>

										</>

									}
								</div>
							</div>


							{/* Bottoni di inizializzazione template (sotto la barra azioni) */}
							{!procedi &&
								<div className='flex gap-2 justify-end'>
									<Button
										className='principal-button'
										size='md'
										text={'Inizializza con template base'}
										icon={<HiOutlineDocumentText className='button-icon' />}
										onClick={() => initFromTemplate(newsletterBaseTemplate, 'base')}
									/>
									<Button
										className='principal-button'
										size='md'
										text={'Inizializza con template MILLER HR'}
										icon={<HiOutlineDocumentText className='button-icon' />}
										onClick={() => initFromTemplate(newsletterMillerHrTemplate, 'MILLER HR')}
									/>
								</div>
							}

							{/* Invii programmati ANCORA DA INVIARE (pending): gestibili, eliminabili */}
							{programmazioniPending.length > 0 &&
								<div className='border border-blue-200 bg-blue-50 rounded-md p-2 flex flex-col gap-1'>
									<div className='text-sm font-bold flex items-center gap-2'>
										<HiOutlineClock size={16} /> Invii programmati ({programmazioniPending.length})
									</div>
									<div className='flex flex-col gap-1 max-h-32 overflow-auto'>
										{programmazioniPending.map((p) => (
											<div key={p.id} className='flex flex-row items-center justify-between bg-white rounded px-2 py-1 text-xs border border-gray-200'>
												<div className='flex flex-row items-center gap-2'>
													<span className='font-mono'>{moment(p.programmata_per).format('DD/MM/YYYY HH:mm')}</span>
													<span className='text-gray-500'>· {p.numero_destinatari} dest.</span>
													<span className={`px-1.5 py-0.5 rounded text-[10px] font-semibold ${p.stato === 'errore' ? 'bg-red-100 text-red-800' : p.stato === 'in_invio' ? 'bg-amber-100 text-amber-800' : 'bg-blue-100 text-blue-800'}`}>{p.stato}</span>
													{p.stato === 'errore' && p.errore && (
														<span className='text-red-600 truncate max-w-[200px]' title={p.errore}>{p.errore}</span>
													)}
												</div>
												{p.stato !== 'in_invio' && (
													<button type='button' className='text-red-600 hover:text-red-800 flex items-center' title='Elimina programmazione' onClick={() => deleteProgrammazione(p.id)}>
														<HiOutlineTrash size={15} />
													</button>
												)}
											</div>
										))}
									</div>
								</div>
							}

							{/* File input sempre montato: l'allegato viene salvato sulla newsletter */}
							<input
								id="uploadDoc"
								type="file"
								//accept="application/pdf"
								className="hidden"
								onChange={handleFileChange}
								multiple
							/>

							{/* File input per "Genera URL da file": NON allega alla newsletter,
									carica su S3 e copia l'URL pubblico negli appunti. */}
							<input
								id="uploadUrlFile"
								type="file"
								className="hidden"
								onChange={handleGenerateUrlFileChange}
							/>

							{/* Lista allegati: una "chip" per ognuno con bottone X dedicato.
									Visibile sia in editor sia in procedi. Multi-file supportato:
									l'utente può aggiungere altri file cliccando "Allega" anche
									quando ce ne sono già presenti. */}
							{allegati.length > 0 &&
								<div className='flex flex-col gap-1'>
									<label className='text-xs text-gray-600'>Allegati ({allegati.length})</label>
									<div className='flex flex-row flex-wrap gap-2 items-center'>
										{allegati.map((el) => (
											<div
												key={el.file}
												className='flex flex-row items-center gap-2 px-3 py-1 rounded-full border border-gray-300 bg-gray-50 text-sm'
												title={`${el.name}${el.size ? ` (${Math.round(el.size / 1024)} KB)` : ''}`}
											>
												<HiOutlinePaperClip size={14} />
												<span className='max-w-[260px] truncate'>{el.name}</span>
												<button
													type='button'
													className='text-red-600 hover:text-red-800 flex items-center'
													title='Rimuovi questo allegato'
													onClick={() => handleRemoveOne(el.file)}
												>
													<HiOutlineX size={16} />
												</button>
											</div>
										))}
										{allegati.length > 1 && (
											<Button
												className='error-button'
												size='sm'
												text={'Rimuovi tutti'}
												icon={<HiOutlineX className='button-icon' />}
												onClick={handleRemove}
											/>
										)}
									</div>
								</div>
							}

							{/* Pannello "procedi" (visibile solo quando procedi=true) */}
							{procedi && (
								<>
									<div className='w-full flex-1 min-h-0 grid grid-cols-2 gap-2'>
										<div className='flex flex-col gap-2'>

											<div dangerouslySetInnerHTML={{ __html: htmlMail }} />
										</div>
										<div className='flex flex-col gap-3 overflow-auto'>
											<div className='font-bold'>Elenchi destinatari</div>
											<div className='grid grid-cols-2 gap-1'>
												{ELENCHI.map(el => (
													<label key={el.id} className='flex items-center gap-2'>
														<input
															type='checkbox'
															checked={elenchiSel.includes(el.id)}
															onChange={() => toggleElenco(el.id)}
														/>
														<span>{el.label}</span>
														{el.descrizione && (
															<Tooltip title={el.descrizione} arrow placement='right'>
																<span className='cursor-help text-gray-400 hover:text-gray-600'>
																	<MdInfoOutline size={16} />
																</span>
															</Tooltip>
														)}
													</label>
												))}
											</div>

											<div className='border border-gray-300 rounded-md p-3 mt-2 flex flex-col gap-3 bg-gray-50'>
												<div className='text-sm text-gray-700'>
													Filtri applicati solo agli elenchi <span className='font-bold'>Clienti HR Italia</span> e <span className='font-bold'>Clienti HR Estero</span>
												</div>
												<div>
													<label className='text-sm'>CCNL</label>
													<Select
														isMulti
														value={filtroCcnl}
														onChange={(v) => { setConferma(false); setFiltroCcnl(v || []); }}
														options={ccnl.map((el) => ({ value: el.id, label: el.name }))}
														placeholder='Seleziona CCNL...'
													/>
												</div>
												<div>
													<label className='text-sm'>Tipo fatturazione</label>
													<Select
														isMulti
														value={filtroFatt}
														onChange={(v) => { setConferma(false); setFiltroFatt(v || []); }}
														options={FATTURAZIONE_OPTIONS}
														placeholder='Tutti'
													/>
												</div>
												<div className='flex flex-col gap-1 border border-gray-200 rounded p-2 bg-white'>
													<label className='flex items-center gap-2 text-sm'>
														<input
															type='checkbox'
															checked={filtroDim.enabled}
															onChange={(e) => { setConferma(false); setFiltroDim({ ...filtroDim, enabled: e.target.checked }); }}
														/>
														Filtra per dimensione azienda (cedolini elaborati)
													</label>
													{filtroDim.enabled && (
														<div className='flex flex-row gap-2 items-center'>
															<input
																type='month'
																value={filtroDim.mese}
																onChange={(e) => setFiltroDim({ ...filtroDim, mese: e.target.value })}
																className='border rounded px-2 py-1 text-sm'
															/>
															<select
																value={filtroDim.op}
																onChange={(e) => setFiltroDim({ ...filtroDim, op: e.target.value })}
																className='border rounded px-2 py-1 text-sm'
															>
																<option value='<='>≤</option>
																<option value='>='>≥</option>
															</select>
															<input
																type='number'
																min='0'
																value={filtroDim.valore}
																onChange={(e) => setFiltroDim({ ...filtroDim, valore: e.target.value })}
																className='border rounded px-2 py-1 text-sm w-24'
															/>
															<span className='text-sm'>cedolini</span>
														</div>
													)}
												</div>
											</div>

											<div>
												<label className='text-sm'>Email aggiuntive (separate da virgola, ; o spazio)</label>
												<textarea
													value={mailExtra}
													onChange={(e) => { setConferma(false); setMailExtra(e.target.value); }}
													className='w-full border rounded p-1 text-sm'
													rows={2}
													placeholder='es. mario@rossi.it, anna@verdi.it'
												/>
											</div>

											<div className='bg-gray-100 rounded p-2 text-sm'>
												<div className='font-bold'>Anteprima destinatari: {preview.totale}</div>
												{preview.per_elenco && preview.per_elenco.filter(p => p.count > 0).map(p => (
													<div key={p.elenco}>
														{p.elenco === 0 ? 'Email singole' : ELENCHI.find(e => e.id === p.elenco)?.label}: {p.count}
													</div>
												))}
											</div>

											{preview.sample && preview.sample.length > 0 && (() => {
												const q = sampleSearch.trim().toLowerCase();
												const filtered = q
													? preview.sample.filter(d =>
														(d.email || '').toLowerCase().includes(q) ||
														(d.nominativo || '').toLowerCase().includes(q)
													)
													: preview.sample;
												return (
													<details className='bg-gray-50 border border-gray-200 rounded p-2 text-xs'>
														<summary className='cursor-pointer font-semibold text-gray-700'>
															Mostra elenco email ({preview.sample.length})
														</summary>
														<input
															type='text'
															placeholder='Cerca email o nominativo...'
															value={sampleSearch}
															onChange={(e) => setSampleSearch(e.target.value)}
															onClick={(e) => e.stopPropagation()}
															className='mt-2 w-full px-2 py-1 border border-gray-300 rounded text-xs'
														/>
														<div className='mt-2 max-h-48 overflow-auto flex flex-col gap-1'>
															{filtered.map((d, i) => (
																<div key={`${d.email}-${i}`} className='flex flex-row gap-2 items-center justify-between border-b border-gray-100 pb-1'>
																	<div className='flex flex-col'>
																		<span className='font-mono'>{d.email}</span>
																		{d.nominativo && (
																			<span className='text-gray-500 text-[10px]'>{d.nominativo}</span>
																		)}
																	</div>
																	<div className='flex flex-row gap-1'>
																		{(d.elenchi || []).map(e => (
																			<span key={e} className='inline-block px-1.5 py-0.5 rounded bg-blue-100 text-blue-800 text-[10px] font-medium'>
																				{e === 0 ? 'singola' : `el. ${e}`}
																			</span>
																		))}
																	</div>
																</div>
															))}
															{filtered.length === 0 && (
																<div className='text-gray-500 italic text-center mt-1'>
																	Nessun risultato
																</div>
															)}
														</div>
													</details>
												);
											})()}

											{conferma &&
												<div className='flex flex-col justify-center items-center gap-4'>
													{loading ? <CircularProgress /> :
														<>
															<div className='font-bold text-center'>ATTENZIONE: confermi l'invio a {preview.totale} destinatari?</div>
															<Button
																className='success-button'
																size='md'
																text={'Invia'}
																icon={<HiCheck className='button-icon' />}
																onClick={() => { sendToCluster() }}
															/>
														</>
													}
												</div>
											}

											{/* Programmazione invio: alternativa all'invio immediato */}
											<div className='border border-blue-200 rounded-md p-3 mt-2 flex flex-col gap-2 bg-blue-50'>
												<div className='font-bold text-sm flex items-center gap-2'>
													<HiOutlineClock size={16} /> Programma invio
												</div>
												<div className='text-xs text-gray-600'>
													L'invio partirà automaticamente alla data/ora scelta (controllo ogni 10 minuti).
												</div>
												<div className='flex flex-row gap-2 items-center'>
													<input
														type='datetime-local'
														value={programmaData}
														onChange={(e) => setProgrammaData(e.target.value)}
														className='border rounded px-2 py-1 text-sm flex-1'
													/>
													<Button
														className='principal-button'
														size='md'
														text={'Programma'}
														icon={<HiOutlineClock className='button-icon' />}
														onClick={scheduleNewsletter}
													/>
												</div>

												{/* Storico di TUTTI gli invii partiti (manuali + programmati), sola lettura */}
												{inviiEffettuati.length > 0 &&
													<div className='flex flex-col gap-1 mt-1 border-t border-blue-200 pt-2'>
														<div className='text-xs font-semibold text-gray-700'>Invii effettuati ({inviiEffettuati.length})</div>
														<div className='flex flex-col gap-1 max-h-28 overflow-auto'>
															{inviiEffettuati.map((inv, i) => (
																<div key={i} className='flex flex-row items-center gap-2 bg-white rounded px-2 py-1 text-xs border border-gray-200'>
																	<span className='font-mono'>{moment(inv.data_invio).format('DD/MM/YYYY HH:mm')}</span>
																	<span className='text-gray-500'>· {inv.numero_destinatari} dest.</span>
																	{Number(inv.aperture) > 0 &&
																		<span className='text-gray-500'>· {inv.aperture} aperte</span>}
																	{Number(inv.problemi) > 0 &&
																		<span className='px-1.5 py-0.5 rounded text-[10px] font-semibold bg-red-100 text-red-800'>{inv.problemi} problemi</span>}
																	<span className={`px-1.5 py-0.5 rounded text-[10px] font-semibold ${Number(inv.fallito) ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'}`}>
																		{Number(inv.fallito) ? 'fallito' : 'inviata'}
																	</span>
																</div>
															))}
														</div>
													</div>
												}
											</div>
										</div>
									</div>
								</>
							)}

							{/* Editor SEMPRE montato: nascosto con display:none quando si è in procedi.
									Evita lo smontaggio/rimontaggio dell'iframe Unlayer, che è la causa
									principale del bug "Procedi -> Indietro perde le modifiche". */}
							<div
								className='flex-1 min-h-0 flex flex-col'
								style={{ display: procedi ? 'none' : 'flex' }}
							>
								<EmailEditor
									ref={emailEditorRef}
									onLoad={onLoad}
									onReady={onReady}
									options={{ projectId: UNLAYER_PROJECT_ID }}
									minHeight='100%'
									style={{ flex: 1, height: '100%' }}
								/>
							</div>
						</div>
					</div>

				</Modal>,
				document.getElementById("portalModal")
			)}

			<div className='mx-auto w-full page-container gap-4 pt-4'>
				<TabPanel
					tab={tab}
					setTab={setTab}
					tabs={tabs}
					content={[
						{
							id: 1,
							child: (
								<div className='w-full md:h-[70vh] h-[70vh] relative el-container'>
									<DataGridBase
										storageKey="newsletter"
										slots={{ toolbar: CustomToolbar }}
										columns={columns}
										rows={newsletter}
										getRowId={(r) => r.id}
									/>
								</div>
							),
						},
						// Statistiche e Blacklist sono solo per admin/team_leader: i componenti
						// chiamano /newsletter/stats e /newsletter/blacklist (protette requireRole).
						// Se montati per utenti standard ricevono 403 -> logout. Quindi vanno
						// inclusi nel content SOLO se canManage (coerente con la lista `tabs`).
						...(canManage ? [
							{
								id: 2,
								child: <NewsletterStatistiche />,
							},
							{
								id: 3,
								child: <NewsletterBlacklist />,
							},
						] : []),
					]}
				/>
			</div>
		</>
	);
};





/*


  <div className='w-full flex z-50 relative flex-col h-full page-container'>
	  <div>
		<button onClick={exportHtml}>Export HTML</button>
	  </div>
	  
	  <EmailEditor
		ref={emailEditorRef}
		onLoad={onLoad}
		onReady={onReady}
	  />
	</div>

*/





